// oxlint-disable react-perf/jsx-no-new-object-as-prop
import { Details, Box, Icon } from '@palmetto/palmetto-components';
import { ReactNode } from 'react';

type CollapsibleDetailsProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export const CollapsibleDetails = ({ title, isOpen, onToggle, children }: CollapsibleDetailsProps) => (
  <Details
    isOpen={isOpen}
    margin="xs 0 0 0"
    display="block"
    background="primary"
    radius="md"
    borderWidth="xs"
    borderColor="separator"
    width="100"
  >
    <Details.Summary
      isDetailsOpen={isOpen}
      onToggle={onToggle}
      justifyContent="space-between"
      display="flex"
      direction="row"
      alignItems="center"
      padding="md"
    >
      <Box>{title}</Box>

      <Box fontSize="xs" direction="row" alignItems="center" childGap="xs" hover={{ color: 'body-primary' }}>
        <Icon name={isOpen ? 'caret-up' : 'caret-down'} />
      </Box>
    </Details.Summary>

    <Box padding="md" childGap="xs" borderWidth="xs 0 0 0" borderColor="separator" fontSize="sm">
      {children}
    </Box>
  </Details>
);
